import { Button, DatePicker, Space } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

const DueDateFilter = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
  return (
    <div style={{ padding: 8, transition: 'all 0.3s ease', overflow: 'hidden' }}>
      <div className="inline-range-picker">
        <DatePicker.RangePicker
          getPopupContainer={(trigger) => trigger.parentNode}
          onChange={(dates, dateStrings) => {
            if (dateStrings && dateStrings[0] && dateStrings[1]) {
              setSelectedKeys([dateStrings]);
              confirm();
            } else {
              setSelectedKeys([]);
              confirm();
            }
          }}
          key={selectedKeys && selectedKeys.length > 0 ? 'active' : 'inactive'}
          format="DD/MM/YYYY"
          value={selectedKeys[0] && Array.isArray(selectedKeys[0]) ? [dayjs(selectedKeys[0][0], "DD/MM/YYYY"), dayjs(selectedKeys[0][1], "DD/MM/YYYY")] : null}
          style={{ width: '100%', marginBottom: 8 }}
          popupClassName="custom-range-popup"
        />
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
        <Space>
          <Button type="primary" onClick={() => confirm()} size="small">
            Filter
          </Button>
          <Button
            onClick={() => {
              clearFilters();
              confirm();
            }}
            size="small"
            danger
          >
            Reset
          </Button>
        </Space>
      </div>
    </div>
  );
};

export default DueDateFilter;
